import React, { useMemo } from 'react';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import ProductTemplateSidebar from 'components/common/rfq/ProductTemplateSidebar';
import RFQConfigureAttributeForm from 'components/rfq/product-template/rfq-configure-attribute';
import RFQConfigurePlanAttributesStore, {
  PageStoreContext,
} from 'store/pages/rfq/rfq-template/configure-plan-attribute/pageStore';
import { createStyles } from '../../../../globalStyles';

const RFQConfigureAttributePage = (): JSX.Element => {
  const classes = createStyles();
  const pageStore = useMemo(() => new RFQConfigurePlanAttributesStore(), []);

  return (
    <GlobalLayout
      leftSection={<ProductTemplateSidebar />}
      rightSection={
        <div className={classes.pageWrapper}>
          <PageStoreContext.Provider value={pageStore}>
            <RFQConfigureAttributeForm />
          </PageStoreContext.Provider>
        </div>
      }
    />
  );
};

export default RFQConfigureAttributePage;
